module.exports = __webpack_public_path__ + "img/placeholder_both.8b29a5fc.svg";